import { useEffect } from "react";
import { DefaultParameterPage } from "store/api/generatedApi";
import { sendVisitNotification } from "src/utils/sendVisitNotification";

export const useDefaultParameterVisit = ({
  tenantName,
  page,
  isActive,
}: {
  tenantName: string;
  page: DefaultParameterPage;
  isActive: boolean;
}) => {
  useEffect(() => {
    if (!isActive) return;
    const timer = setTimeout(() => {
      void sendVisitNotification({
        path: `default_parameters/${tenantName}/visit`,
        visit: { page },
      });
    }, 0);
    return () => {
      clearTimeout(timer);
    };
  }, [isActive, tenantName, page]);
};
